exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td[data-v-4f69d42c]{border:1px solid #ececec;text-align:center;padding:.16rem .1rem}a[data-v-4f69d42c]{word-break:break-all;cursor:pointer}b[data-v-4f69d42c]{font-weight:700;color:#151515}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4f69d42c","scoped":true,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/pages/landingPage/ecardProtocol.vue
// module id = 653
// module chunks = 20